import styled from "styled-components";


export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
`

export const Container = styled.div`
    flex: auto;
    overflow: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;

    .seeMore{
        position: absolute;
        top: 0.5rem;
        left: 0.2rem;
        font-size: 1.4rem;
        display: flex;
        color: var(--colorFontsCardsDashboard);

        @media (min-width: 960px){
            cursor: pointer;
        }
    }
`

export const Header = styled.div`
    background: var(--colorBackgroundCardsDashboard);
    color: var(--colorFontsCardsDashboard);
    padding: 1rem 0;
    width: 100%;

    display: flex;
    justify-content: space-between;

    strong{
        margin: 0 0.5rem;
        font-size: 1.5rem;
    }
`

export const Table = styled.div`
    margin-bottom: 2.5rem;
`

export const TableLine = styled.div`
    color: var(--colorFontsCardsDashboard);
    padding: 1rem 0;
    width: 100%;

    display: flex;
    justify-content: space-between;

    p{
        margin: 0 0.5rem;
    }
`

export const TotalValue = styled.div`
    width: 100%;
    position: absolute;
    bottom: 0.4rem;
    right: 0;

    border-top: 1px solid var(--colorFontsCardsDashboard);
    background: #FFF;
    font-size: 0.9rem;
    padding: 1rem 0.5rem;

    display: flex;
    align-items: center;
    justify-content: space-between;

    svg{
        font-size: 1rem;
        color: var(--colorFontsCardsDashboard);
    }

    div{
        text-align: center;

        span{
            font-weight: 900;
        }

        p{
            font-size: 0.8rem;
        }
    }

    .red{
        color: #e05f59;
    }

    .blue{
        color: #00008b;
    }

    .green{
        color: #2e9699;
    }
`